import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import { safeSessionStorage } from './safeStorage';

export default ({ form, maxClickpathCount = 100 }) => {
	let clickPath = JSON.parse(
		safeSessionStorage.getItem('ws-tracking-clickpath') || '[]'
	);
	if (clickPath.length > maxClickpathCount) {
		clickPath = clickPath.slice(
			clickPath.length - maxClickpathCount,
			clickPath.length
		);
	}

	const clickPathValue = clickPath
		.map((click) => {
			const { viewType, timestamp, path } = click;
			return `${timestamp}|${viewType}|${path}`;
		})
		.join('^');

	createOrUpdateHiddenField(form, 'clickpath', clickPathValue);
};
